import { ApiClient, ApiClientConfig } from "../../../api-client";
import { ApiClientError, handleApiError } from "../../../errors";
import schemaValidators from "./schema-validators";

export class MediaLoggerClient extends ApiClient<typeof schemaValidators> {
	constructor(config: ApiClientConfig) {
		super(config, schemaValidators);
	}

	logStartRecording = async ({
		sessionId,
		recordingDetails,
	}: {
		sessionId: string;
		recordingDetails: {
			media: "display" | "webcam" | "microphone";
			video?: number;
		};
	}) => {
		const response = await handleApiError(
			super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${sessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					type: "session",
					name: "start recording",
					time: new Date(),
					details: { ...recordingDetails, success: true },
				}),
			}),
		);

		// TODO: Remove this after migration to k8s. k8s returns the recording UUID & ECS returns void
		try {
			const data = (await response.json()) as unknown;
			if (!schemaValidators.logStartRecording.validate(data)) {
				throw new ApiClientError(new Error(`Invalid log start recording: ${JSON.stringify(data)}`));
			}
			return data;
		} catch (error) {
			return "";
		}
	};

	logEndRecording = async ({
		sessionId,
		recordingDetails,
	}: {
		sessionId: string;
		recordingDetails: {
			media: "display" | "webcam" | "microphone";
			video?: number;
		};
	}) => {
		await handleApiError(
			super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${sessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					type: "session",
					name: "end recording",
					time: new Date(),
					details: { ...recordingDetails, success: true },
				}),
			}),
		);
	};

	logEndUpload = async ({
		sessionId,
		recordingDetails,
	}: {
		sessionId: string;
		recordingDetails: {
			media: "display" | "webcam" | "microphone";
			success: boolean;
		};
	}) => {
		await handleApiError(
			super.fetch(`${this.config.verityOrigin}/api/verity/quiz/event/${sessionId}`, {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({
					type: "session",
					name: "end upload",
					time: new Date(),
					details: recordingDetails,
				}),
			}),
		);
	};
}
